<template>
    <div class="layout-tiles" :class="layoutClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutTiles',
    props: {
        tileSpacing: {
            required: false,
            type: String,
            default: 'space-y-3',
        },
        tileDividerColor: {
            required: false,
            type: String,
            default: 'divide-gray-100',
        },
    },
    computed: {
        layoutClasses () {
            const cls = {};
            cls['divide-y mb-3'] = true;
            cls[this.tileSpacing] = true;
            cls[this.tileDividerColor] = true;
            return cls;
        },
    },
};
</script>
